import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);
  // Use a plain ref via closure to prevent double-processing under StrictMode
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    if (processed) return;
    setProcessed(true);

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(res.data.user);
        // Clear hash and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "No se pudo iniciar sesión");
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#F5F5F5]">
      <div className="text-center">
        {error ? (
          <>
            <p className="font-display text-3xl mb-2">Sesión no iniciada</p>
            <p className="text-sm text-neutral-400 mb-6">{error}</p>
            <button className="btn-outline" onClick={() => navigate("/login")}>
              Volver a iniciar
            </button>
          </>
        ) : (
          <>
            <p className="eyebrow mb-3">Autenticando</p>
            <p className="font-display text-3xl">Estableciendo sesión segura…</p>
          </>
        )}
      </div>
    </div>
  );
}
